export class MISProductDetailedReportModel {
    iqfProductsInfo: MISProductInfo[];
    blockProductsInfo: MISProductInfo[];
    totals: ProductAnalysisTotals;
    productionQuantity: ProductionQuantity[];

    constructor(
        iqfProductsInfo: MISProductInfo[],
        blockProductsInfo: MISProductInfo[],
        totals: ProductAnalysisTotals,
        productionQuantity: ProductionQuantity[]
    ) {
        this.iqfProductsInfo = iqfProductsInfo;
        this.blockProductsInfo = blockProductsInfo;
        this.totals = totals;
        this.productionQuantity = productionQuantity;
    }
}

export class MISProductInfo {
    productType: string;
    noOfSlabs: number;
    weightPerSlab: number;
    netTotalWeight: number;
    grossTotalWeight: number;
    yieldPer: number;
    totalEquivalentHeadOnWeight: number;
    production: number;
    va1:number;

    constructor(
        productType: string,
        noOfSlabs: number,
        weightPerSlab: number,
        netTotalWeight: number,
        grossTotalWeight: number,
        yieldPer: number,
        totalEquivalentHeadOnWeight: number,
        production: number,
        va1:number
    ) {
        this.productType = productType;
        this.noOfSlabs = noOfSlabs;
        this.weightPerSlab = weightPerSlab;
        this.netTotalWeight = netTotalWeight;
        this.grossTotalWeight = grossTotalWeight;
        this.yieldPer = yieldPer;
        this.totalEquivalentHeadOnWeight = totalEquivalentHeadOnWeight;
        this.production = production;
        this.va1= va1
    }
}

export class ProductAnalysisTotals {
    totalNumberOfSlabs: number;
    totalWeightPerSlab: number;
    totalNetWeight: number;
    totalGrossWeight: number;
    totalHeadOnWeight: number;
    totalProduction: number;
    totalYieldPercent: number;
    totalProductionPercent: number;

    constructor(
        totalNumberOfSlabs: number,
        totalWeightPerSlab: number,
        totalNetWeight: number,
        totalGrossWeight: number,
        totalHeadOnWeight: number,
        totalProduction: number,
        totalYieldPercent: number,
        totalProductionPercent: number
    ) {
        this.totalNumberOfSlabs = totalNumberOfSlabs;
        this.totalWeightPerSlab = totalWeightPerSlab;
        this.totalNetWeight = totalNetWeight;
        this.totalGrossWeight = totalGrossWeight;
        this.totalHeadOnWeight = totalHeadOnWeight;
        this.totalProduction = totalProduction;
        this.totalYieldPercent = totalYieldPercent;
        this.totalProductionPercent = totalProductionPercent;
    }
}

export class ProductionQuantity {
    grnItemId: number;
    grnId: number;
    quantity: number;
    reweighmentQuantity: number;
    grnDate: Date;

    constructor(
        grnItemId: number,
        grnId: number,
        quantity: number,
        reweighmentQuantity: number,
        grnDate: Date
    ) {
        this.grnItemId = grnItemId;
        this.grnId = grnId;
        this.quantity = quantity;
        this.reweighmentQuantity = reweighmentQuantity;
        this.grnDate = grnDate;
    }
}
